import { render, staticRenderFns } from "./TechnicalMessages.vue?vue&type=template&id=b890770c&"
import script from "./TechnicalMessages.vue?vue&type=script&lang=js&"
export * from "./TechnicalMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports